import React from "react";
import { Modal, Button, ConfigProvider } from "antd";

import { workspaceDisplayName } from "../../utils/workspaceDisplayName";

export const SuccessModal = ({
  open,
  deletedUser,
  deleteType = "user",
  bulkDeletedCount,
  deletedUsers,
  isRestoringUsers,
  onRestore,
  onClose
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: 24,
          },
        },
      }}
    >
      <Modal
        title={
          <span style={{ fontFamily: "Inter", fontSize: "20px", fontWeight: 700, color: "#18181b" }}>
            Delete
          </span>
        }
        open={open}
        onCancel={onClose}
        centered
        width={480}
        styles={{
          content: {
            borderRadius: "24px",
            padding: "24px 26px",
          },
          header: {
            padding: 0,
            marginBottom: "24px",
            borderBottom: "none",
          },
          body: {
            padding: 0,
          },
          footer: {
            padding: 0,
            marginTop: "24px",
            borderTop: "none",
          },
        }}
        footer={[
          // Restore only applies to a reversible soft delete (single-user
          // deactivation or bulk). Permanent deletes and workspace removals
          // have nothing to restore.
          deleteType === "user" || bulkDeletedCount > 0 ? (
            <Button
              key="restore"
              type="text"
              onClick={onRestore}
              loading={isRestoringUsers}
              disabled={deletedUsers.length === 0}
              style={{
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: 500,
                color: "#3f3f46",
                height: "36px",
                paddingInline: "16px",
                borderRadius: "9999px",
              }}
            >
              {isRestoringUsers ? "Restoring..." : "Restore"}
            </Button>
          ) : null,
          <Button
            key="done"
            onClick={onClose}
            style={{
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: 500,
              color: "#fff",
              backgroundColor: "#0e49b5",
              border: "none",
              height: "36px",
              paddingInline: "24px",
              borderRadius: "9999px",
            }}
          >
            Done
          </Button>,
        ]}
      >
        <div style={{ fontFamily: "Inter", fontSize: "14px", fontWeight: 400, color: "#18181b", lineHeight: "22px" }}>
          {deletedUser ? (
            deleteType === "permanent" ? (
              <>You have permanently deleted <strong>{deletedUser.name}</strong> from <strong>DashONE</strong>.</>
            ) : deleteType === "user" ? (
              <>You have deactivated <strong>{deletedUser.name}</strong>. They can be restored anytime from the <strong>Deactivated</strong> view.</>
            ) : (
              <>You have removed <strong>{deletedUser.name}</strong> from the <strong>{workspaceDisplayName(deletedUser.client)}</strong> workspace.{(deletedUser.workspaceCount ?? 1) > 1 ? <> They still have access to their {(deletedUser.workspaceCount ?? 1) - 1 === 1 ? "1 other workspace" : `${(deletedUser.workspaceCount ?? 1) - 1} other workspaces`} and remain active there.</> : null}</>
            )
          ) : bulkDeletedCount > 0 ? (
            <>You have deactivated <strong>{bulkDeletedCount} users</strong>. They can be restored from the <strong>Deactivated</strong> view.</>
          ) : null}
        </div>
      </Modal>
    </ConfigProvider>
  );
};
